import api from '../api';
import {
  IAcademicYearPayload,
  ICreateAcademicYearResponse,
  IAcademicYearListResponse,
  IAcademicYearListParams,
} from '../../interface/academicYear.interface';

export const postAcademicYear = async (
  payload: IAcademicYearPayload,
): Promise<ICreateAcademicYearResponse> => {
  const response = await api.post<ICreateAcademicYearResponse>('/academic-year', payload);
  return response.data;
};

export const fetchAcademicYears = async (params: IAcademicYearListParams) => {
  const res = await api.get<IAcademicYearListResponse>('/academic-year', { params });
  return res.data;
};

export const updateAcademicYear = async (id: string, payload: IAcademicYearPayload) => {
  const response = await api.patch(`/academic-year/${id}`, payload);
  return response.data;
};

export const deleteAcademicYear = async (id: string) => {
  const response = await api.delete(`/academic-year/${id}`);
  return response.data;
};

const academicYearService = {
  postAcademicYear,
  fetchAcademicYears,
  updateAcademicYear,
  deleteAcademicYear,
};

export default academicYearService;
